import { IconPlay } from './IconPlay'

export default IconPlay
